var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_vm._l((_vm.items),function(item,index){return [_c('component',_vm._b({},'component',_vm.$_attributes(item, index),false))]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }